import { render, staticRenderFns } from "./liveBackMore.vue?vue&type=template&id=4720dce6&scoped=true&"
import script from "./liveBackMore.vue?vue&type=script&lang=js&"
export * from "./liveBackMore.vue?vue&type=script&lang=js&"
import style0 from "./liveBackMore.vue?vue&type=style&index=0&id=4720dce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4720dce6",
  null
  
)

export default component.exports